export default "__VITE_ASSET__Ck4CM9fi__"